import CampaignService from "@/services/campaignService";

import { create } from "zustand";

const useCampaignsStore = create((set) => ({
  loading: false,
  campaigns: [],
  filters: {
    query: "",
  },
  // Application State
  applications: [],
  applicationFilters: {
    query: "",
    status: "ALL",
    campaignId: "",
  },
  applicationError: null,
  validCampaigns: [],
  getCampaigns: async () => {
    set({ loading: true });
    const response = await CampaignService.getCampaigns();
    const campaigns = response?.data || [];

    // Client-side filtering
    const filters = useCampaignsStore.getState().filters;
    let filtered = campaigns;

    if (filters.query) {
      const lowerQuery = filters.query.toLowerCase();
      filtered = filtered.filter(
        (c) =>
          c.name?.toLowerCase().includes(lowerQuery) ||
          c.description?.toLowerCase().includes(lowerQuery),
      );
    }

    set({
      campaigns: filtered,
      loading: false,
    });
  },
  setFilters: (filters) => {
    set({ filters });
  },
  // Application Actions
  getValidCampaigns: async () => {
    try {
      const response = await CampaignService.getValidCampaigns();
      set({ validCampaigns: response?.data || [] });
    } catch {
      set({ validCampaigns: [] });
    }
  },
  getApplications: async () => {
    set({ loading: true, applicationError: null });
    try {
      const filters = useCampaignsStore.getState().applicationFilters;
      const response = await CampaignService.getApplications({
        status: filters.status,
        campaignId: filters.campaignId,
      });
      const applications = response?.data || [];

      // Client-side filtering for query/search
      let filtered = applications;

      if (filters.query) {
        const lowerQuery = filters.query.toLowerCase();
        filtered = filtered.filter(
          (app) =>
            app.customerFirstName?.toLowerCase().includes(lowerQuery) ||
            app.customerLastName?.toLowerCase().includes(lowerQuery) ||
            app.customerEmail?.toLowerCase().includes(lowerQuery) ||
            app.customerPhone?.toLowerCase().includes(lowerQuery) ||
            app.merchantProductId?.toString().includes(lowerQuery) ||
            app.campaignName?.toLowerCase().includes(lowerQuery),
        );
      }

      set({
        applications: filtered,
        loading: false,
      });
    } catch (error) {
      set({
        applications: [],
        loading: false,
        applicationError:
          error?.response?.data?.message || error?.message || "Bir hata oluştu",
      });
    }
  },
  setApplicationFilters: (filters) => {
    set({ applicationFilters: filters });
  },
  approveApplication: async (id, reviewComment = "") => {
    await CampaignService.approveApplication(id, {
      applicationId: id,
      applicantStatus: "APPROVED",
      reviewComment,
    });
    await useCampaignsStore.getState().getApplications();
  },
  rejectApplication: async (id, reason) => {
    await CampaignService.rejectApplication(id, {
      applicationId: id,
      applicantStatus: "REJECTED",
      reviewComment: reason,
    });
    await useCampaignsStore.getState().getApplications();
  },
}));

export default useCampaignsStore;
